import React, { useEffect } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { Row, Col } from "react-bootstrap";
import DashHeader from "./DashHeader";
import { useNavigate, useParams } from "react-router-dom";
import { listBotDetails } from "../actions/botActions";
import { useDispatch, useSelector } from "react-redux";
import LeftArrowLoT from "../lottie-files/LeftArrowLoT";
import lottie from "lottie-web";
import { Helmet } from "react-helmet-async";
import PreloaderProductInfo from "./PreloaderProductInfo";
import axios from "axios";
import { addToCart } from "../actions/cartActions";
import { getUserSMEDetails } from "../actions/userActions";
import { pushLinkToGlobalState } from "../actions/linkActions";
import UserValidatorModular from "./UserValidatorModular";

function ProductIntro() {
  let param = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  let currentUrl = window.location.href;
  let index = currentUrl.indexOf("/dashboard");
  let splitUrl = currentUrl.substring(index);
  dispatch(pushLinkToGlobalState(splitUrl));

  const { userInfo } = useSelector((state) => state.userLogin);

  const addToCartHandler = () => {
    dispatch(addToCart());
  };

  useEffect(() => {
    dispatch(listBotDetails(param.id));
    dispatch(getUserSMEDetails(param.id));
  }, [dispatch, param.id]);

  const botDetails = useSelector((state) => state.botDetails);
  const { bot } = botDetails;

  const { sme } = useSelector((state) => state.userSMEDetails);
  const tokenCount = sme?.tokenCount;

  let historyId = "";

  const submitHandler = (e) => {
    e.preventDefault();
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };
    axios
      .post(
        "/api/users/use-token/",
        {
          user: userInfo?.id,
        },
        config
      )
      .then(function (response) {
        console.log("Token Response Received");
      })
      .catch(function (error) {
        console.log("Token Error Occurred");
      });

    axios
      .post("/api/legal-tool-history/started/", {
        user: userInfo?.id,
        bot: param.id,
      })
      .then(function (response) {
        console.log("Response Received");
        historyId = response.data.id;
        navigate(`/dashboard/bot/${historyId}/${param.id}`);
      })
      .catch(function (error) {
        console.log("history Error Occurred");
      });
  };

  return (
    <>
      <Col className="dashboard-scrollable-container" lg={9} md={12}>
        <Helmet>
          <title>{"Legal Product -" + bot?.name}</title>
          <meta name="description" content={bot?.excerpt} />
          <link
            rel="canonical"
            href={"/dashboard/legal-products/intro/" + bot?.id}
          />
        </Helmet>

        <DashHeader pageTitle={"Legal Products"} />

        <Row className="dashboard-content-container">
          <Row className="dashboard-content-divider"></Row>

          {bot?.name ? (
            <Row className="product-intro-columns-wrapper ll-product-intro-wrapper">
              <Col className="product-intro-column" align="center">
                <Row>
                  <Col className="ll-prod-button-container" lg={3}>
                    <LinkContainer
                      to={`/dashboard/legal-products`}
                      onMouseEnter={() => lottie.play("ll-prod-back")}
                      onMouseLeave={() => lottie.stop("ll-prod-back")}
                    >
                      <button className="ll-back-button-orange pe-3 ps-1">
                        <LeftArrowLoT aniName="ll-prod-back" />
                        Back
                      </button>
                    </LinkContainer>
                  </Col>
                  <Col align="left" className="ll-prod-title mt-2" lg={9}>
                    <h2 className="serious-font">{bot?.name}</h2>
                  </Col>
                </Row>
                <Row className="mt-4">{bot?.description}</Row>
                <Row className="mt-4">
                  <h3 className="serious-font">Category</h3>
                </Row>
                <Row align="left" className="mt-4 ll-neomorphic-inset ">
                  {bot?.categories?.map((category) => (
                    <div className="pt-2">
                      <div className="lcn-tag-orange bot-category px-2">
                        {category}
                      </div>
                    </div>
                  ))}
                </Row>
              </Col>
              <Col className="product-intro-column prod-mobile-margin">
                {/*  */}
                {(userInfo?.profile === 1 || userInfo?.profile === 0) && (
                  <div>
                    <Row>
                      <Col align="center">
                        <img
                          className="product-intro-image"
                          alt="Lacoona Legal Bots"
                          src="https://laccona-django-react-bucket.s3.af-south-1.amazonaws.com/lacoona-flow-image-bg-1024x1024.png"
                        ></img>
                      </Col>
                    </Row>
                    <Row className="mt-5">
                      <Col align="center">
                        {tokenCount > 0 && (
                          <button
                            id="prod-intro-start-button"
                            className="lcn-button-brown"
                            onClick={submitHandler}
                          >
                            {tokenCount <= 50 ? (
                              <Row>
                                <Col>
                                  <Row>
                                    <h3 className="serious-font">Start</h3>
                                  </Row>
                                  <Row className="use-credit">Use 1 credit</Row>
                                </Col>
                                <Col align="center">
                                  <div className="product-intro-credit-number">
                                    {tokenCount}
                                  </div>
                                </Col>
                              </Row>
                            ) : (
                              <Row>
                                <h5 className="serious-font pt-1">
                                  Start Legal Flow
                                </h5>
                              </Row>
                            )}
                          </button>
                        )}
                        {tokenCount === 0 && (
                          <LinkContainer to={"/cart"}>
                            <button
                              className="lcn-button-brown"
                              onClick={addToCartHandler}
                            >
                              Upgrade
                            </button>
                          </LinkContainer>
                        )}
                      </Col>
                    </Row>
                  </div>
                )}
                {userInfo &&
                  !(userInfo.profile === 1 || userInfo.profile === 0) && (
                    <Col align="center" className="">
                      <Row className="">
                        <Col align="center" className="notification-card">
                          <h3 className="serious-font">
                            Unfortunately this product is only available to SMEs
                          </h3>
                        </Col>
                      </Row>
                    </Col>
                  )}
                {!userInfo ? (
                  <UserValidatorModular />
                ) : (
                  userInfo?.profile === 0 && <UserValidatorModular />
                )}
              </Col>
            </Row>
          ) : (
            <Row className="product-intro-columns-wrapper px-5 ll-product-intro-wrapper">
              <PreloaderProductInfo />
            </Row>
          )}
        </Row>
      </Col>
    </>
  );
}

export default ProductIntro;
